//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionAutoRenew(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M19 11V13C19 14.3261 18.4732 15.5979 17.5355 16.5355C16.5979 17.4732 15.3261 18 14 18H7.24L9.76 15H7.15L3.79 19L7.14 23H9.75L7.24 20H14C15.8565 20 17.637 19.2625 18.9497 17.9497C20.2625 16.637 21 14.8565 21 13V11H19ZM5 11C5 9.67392 5.52678 8.40215 6.46447 7.46447C7.40215 6.52678 8.67392 6 10 6H16.76L14.24 9H16.85L20.21 5L16.85 1H14.24L16.76 4H10C8.14348 4 6.36301 4.7375 5.05025 6.05025C3.7375 7.36301 3 9.14348 3 11V13H5V11Z" fill="currentColor" /></svg>;
}
export default IconActionAutoRenew;